import SelfReportedIncomeController from 'partial/OfferManager/modules/SelfReportedIncome/SelfReportedIncomeController';

export default SelfReportedIncomeController;
